import React from "react";
import "./styles.css";

const MpButtonSecondary = ({ CTA_TEXT, onCtaClick, customStyle }) => {
  return <div className="mp-secondary-button" style={customStyle} onClick={onCtaClick}>{CTA_TEXT}</div>;
};

export default MpButtonSecondary;
